import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeIsvPercenField: (value: Nullable<number>) => void;
}

const IsvPercenField: React.FC<IProps> = ({ changeIsvPercenField }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterIsvPercen') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeIsvPercenField(value);
		},
		[changeIsvPercenField],
	);

	return (
		<FormInput
			testId="IsvPercenField"
			name="isvPercen"
			label="isvPercenLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={2}
		/>
	);
};

export default React.memo(IsvPercenField);
